// Composable to set a localized page title in one line of code.
export default function useLocalizedPageTitle(
  englishTitle: string,
  dutchTitle: string,
) {
  const { t } = useI18n({
    messages: {
      en: {
        pageTitle: englishTitle,
      },
      nl: {
        pageTitle: dutchTitle,
      },
    },
  })
  usePageTitle(computed(() => t('pageTitle')))
}
